// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__11RU3","box":"WorkspacesBox_box__1ucJ6","node":"WorkspacesBox_node__2spIW"};